import {
  api,
  type IPaymentListChannels,
  type PurchasePaymentChannel,
} from '@setplex/tria-api'
import { attach, createStore, sample } from 'effector'
import {
  NoPaymentChannel,
  type PaymentChannel,
} from '~/features/payment/interfaces'
import {
  anyPaymentInitiated,
  closePaymentPopup,
  closePaymentPopupWithType,
  openPaymentPopupWithType,
} from './model'

// this effect is only for request right before purchase - user inits purchase
export const getListPaymentChannelsBeforePurchaseFx = attach({
  effect: api.purchases.getListPaymentChannelsFx,
})

export const extractPaymentChannel = (
  payload: IPaymentListChannels
  // payload - ordered array
): PurchasePaymentChannel | null => payload[0]

sample({
  clock: getListPaymentChannelsBeforePurchaseFx.doneData,
  fn: (clockData) => extractPaymentChannel(clockData) || NoPaymentChannel,
  target: openPaymentPopupWithType,
})

export const $prioritizedPaymentChannel = //
  createStore<PaymentChannel | null>(null).on(
    getListPaymentChannelsBeforePurchaseFx.doneData,
    (_, payload) => extractPaymentChannel(payload) || NoPaymentChannel
  )

sample({
  clock: closePaymentPopup,
  source: { channelType: $prioritizedPaymentChannel },
  fn: ({ channelType }) => channelType,
  target: closePaymentPopupWithType,
})

sample({
  clock: anyPaymentInitiated,
  target: getListPaymentChannelsBeforePurchaseFx,
})
